import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { useLocalizationContext } from '../../context';

// ────────────────────────────────────────────────────────────────────────────────

export const useForgotPasswordForm = () => {
  const { t } = useLocalizationContext();

  const requiredFieldMessage = t('form.validation-required');
  const invalidEmail = t('form.validation-email');

  const validationSchema = useMemo(
    () =>
      yup
        .object({
          email: yup
            .string()
            .email(invalidEmail)
            .required(requiredFieldMessage),
        })
        .required(),
    [invalidEmail, requiredFieldMessage],
  );

  // ────────────────────────────────────────────────────────────────────

  const form = useForm<ForgotPasswordFormData>({
    defaultValues: {
      email: '',
    },
    resolver: yupResolver(validationSchema),
    mode: 'onBlur',
  });

  // ────────────────────────────────────────────────────────────────────

  return { form };
};

// ─── TYPES ──────────────────────────────────────────────────────────────────────

export type ForgotPasswordFormData = {
  readonly email: string;
};
